import { LINK_CONTEXT_MENU } from 'owa-compose-link';
import { trace } from 'owa-trace';
import { ChangeSource, ContentChangedEvent, PluginEvent } from 'roosterjs-editor-types';
import LinkPlugin from '../plugin/LinkPlugin';
import { LinkIdContainer } from '../schema/LinkIdContainer';
import { AnchorElementsSource } from '../types/AnchorElementsSource';
import { UPGRADE_CHANGE_SOURCE, RESTORE_CURSOR_CHANGE_SOURCE } from './constants';
import { processAllLinksInEditor } from './processAllLinksInEditor';

export default async function processContentChangedEvent(
    event: PluginEvent,
    linkPlugin: LinkPlugin,
    linkIdContainer: LinkIdContainer,
    linkIdsWithSpinner: string[]
) {
    const contentChangedEvent: ContentChangedEvent = event as ContentChangedEvent;
    trace.info(`LinkPlugin.processContentChangedEvent: ${contentChangedEvent.source}`);
    if (
        contentChangedEvent.source === ChangeSource.SetContent || // load from draft, undo
        contentChangedEvent.source === UPGRADE_CHANGE_SOURCE || // the original content is added for reply or forward
        contentChangedEvent.source === LINK_CONTEXT_MENU || // users undo beautification or edit hyper link from link context menu items
        contentChangedEvent.source === RESTORE_CURSOR_CHANGE_SOURCE // When user leaves and comes back to the tab, editor will set the content to fix the focus issue.
    ) {
        const AnchorElementsSource = getAnchorElementsSourceFromContentChangedEvent(
            contentChangedEvent.source
        );
        await processAllLinksInEditor(
            linkPlugin,
            linkIdContainer,
            linkIdsWithSpinner,
            contentChangedEvent.source === UPGRADE_CHANGE_SOURCE /* shouldChangeLinkId */,
            AnchorElementsSource
        );
    }
}

function getAnchorElementsSourceFromContentChangedEvent(eventSource: string): AnchorElementsSource {
    if (eventSource === ChangeSource.SetContent) {
        return AnchorElementsSource.DraftOrUndoOrReply;
    }
    if (eventSource === UPGRADE_CHANGE_SOURCE) {
        return AnchorElementsSource.ReplyOrForward;
    }

    // Bug #52532 - this is here to re-make the getSharingInfo call when we undo beautification.
    // We should re-use our existing sharingInfo instead.
    if (eventSource === LINK_CONTEXT_MENU) {
        return AnchorElementsSource.LinkContextMenu;
    }

    if (eventSource === RESTORE_CURSOR_CHANGE_SOURCE) {
        return AnchorElementsSource.RestoreCursor;
    }

    trace.error('anchor element source was not detected');
    return AnchorElementsSource.Unknown;
}
